



















import { Component, Vue } from "vue-property-decorator";
import { version } from "../../../package.json";

@Component
export default class Footer extends Vue {
  private CurrentYear = new Date().getFullYear();
  private version: string = version;
}
